/* RESPONSIBLE TEAM: team-data-foundations */
import ApplicationAdapter from 'embercom/adapters/application';

export default ApplicationAdapter.extend({
  urlForCreateRecord(_, snapshot) {
    let { id } = snapshot.record.appPackage.content;
    return `ember/appstore/app_packages/${id}/invitations`;
  },
});
